export default class ScrollingNumber {
  init() {
    this.observeAnimations();
  }

  observeAnimations() {
    let animatedElements = document.querySelectorAll(
      '.scrolling-number__number'
    );

    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const element = entry.target;

          let countFrom = parseInt(element.textContent);

          if (isNaN(countFrom)) {
            countFrom = 0;
          }

          let jsonDatas;

          try {
            jsonDatas = JSON.parse(element.getAttribute('data-json'));
          } catch (error) {
            console.error('Erreur de parsing JSON :', error);

            return;
          }

          let countTo = parseInt(jsonDatas.count) || 0;
          let timer = parseInt(jsonDatas.speed) || 5000;
          let activeScrolling = parseInt(jsonDatas.activate_scrolling) || false;

          if (!activeScrolling) {
            // If animation disabled, show final number
            element.innerText = countTo;

            return;
          }

          let minTimePerCount = 500;
          let timePerCount = timer / countTo;
          let bonus = 1;

          if (timePerCount > minTimePerCount) {
            timePerCount = minTimePerCount;
          }

          if (countTo >= 1000) {
            bonus = 5;
          }

          if (countTo > 10000) {
            bonus = 50;
          }

          if (countTo > 100000) {
            bonus = 500;
          }

          if (entry.isIntersecting && activeScrolling) {
            let counts = setInterval(() => {
              countFrom += bonus;

              if (countFrom >= countTo) {
                element.innerText = countTo;
                clearInterval(counts);
              } else {
                element.innerText = countFrom;
              }
            }, timePerCount);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: [0.1, 0.5, 0.7, 1],
      }
    );

    animatedElements.forEach((element) => {
      observer.observe(element);
    });
  }
}
